

import AppBar from '@mui/material/AppBar';
import { makeStyles } from "@mui/styles";
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/Drawer';
import Link from '@mui/material/Link';
import MenuItem from '@mui/material/MenuItem';
import { ThemeProvider, createTheme } from '@mui/material/styles';

  import MenuIcon from '@mui/icons-material/Menu';
  import React, { useState, useEffect } from "react";
  import { Link as RouterLink } from "react-router-dom";
  
  const headersData = [
    {
      label: "الرئيسية",
      href: "/logout",
      sectionID:"home",
    },
    {
      label: "من نحن",
      href: "/account",
      sectionID:"how-we-are",
    },
    {
      label: "الخدمات",
      href: "/mentors",
      sectionID:"services",
    },
    {
      label: "تواصل معنا",
      href: "/listings",
      sectionID:"contact-us",
    },
    
    
    
  ];
  
  const useStyles = makeStyles(() => ({
    typography: {
      root: {
        fontFamily: "'Tajawal', sans-serif",
        fontWeight: 400,
        fontSize: 16,
        color: "red"
      }
    },
    header: {
      backgroundColor: "#15558d",
      paddingRight: "79px",
      paddingLeft: "118px",
      "@media (max-width: 900px)": {
        paddingRight: 0,
      },
    },
    logo: {
      fontFamily: " 'Tajawal', sans-serif",
      fontWeight: 600,
      color: "#FFFEFE",
      textAlign: "left",
    },
    menuButton: {
      fontFamily: " 'Tajawal', sans-serif",
      backgroundColor: '#15558D',
      color: '#fff',
      fontSize: '16px',
      marginLeft:'8px',
      borderRadius: '14px'
    },
    toolbar: {
      display: "flex",
      justifyContent: "space-between",
    },
    drawerContainer: {
      padding: "20px 30px",
    },
  }));
  const darkTheme = createTheme({
    components: {
      // Name of the component
      MuiTypography:{
        styleOverrides: {
          root:{
            // Some CSS
            
            fontFamily: " 'Tajawal', sans-serif",
            color:'#15558D'
          },
          h5:{
            fontSize: '22px',
          },
          h6:{
            fontSize: '18px',
          }
        },
      },     
    
      MuiButton: {
        styleOverrides: {
          // Name of the slot
          root: {
            // Some CSS
            marginRight:'10px',
            fontSize: '18px',
            fontFamily: " 'Tajawal', sans-serif",
            color:'#15558D',
            textShadow: '0px 5px 5px #15558D55',
            // '&:hover': {
            //   backgroundColor: '#15558D',
            //   color: '#fff',
            //   fontSize: '16px',
            //   marginLeft:'8px',
            //   borderRadius: '14px'

            // },
          },
          
        },
      },
      MuiAppBar: {
        styleOverrides: {
          colorPrimary: {
            backgroundColor: "#fff"
          },
          // palette: {
          //   action: {
          //       selected: '#E7A615',
          //       hover: '#FFD371',
          //       disabled: '#9B9B9B'
          //   }
        // }
        }
      }
    },
   
    // typography: {
    //   root:{
    //     fontFamily: " 'Tajawal', sans-serif",
    //   }
    // },

    // palette: {
      
    //   primary: {
    //     main: '#fff',
    //   },
    // },
  });
  export default function Header() {
    const { header, toolbar, drawerContainer } = useStyles();
  
    const [state, setState] = useState({
      mobileView: false,
      drawerOpen: false,
    });
  
    const { mobileView, drawerOpen } = state;
    
    const [scrollPosition, setScrollPosition] = useState(0);
    const handleScroll = () => {
      const position = window.pageYOffset;
      setScrollPosition(position);
    };

    useEffect(() => {
      window.addEventListener('scroll', handleScroll, { passive: true });

      return () => {
          window.removeEventListener('scroll', handleScroll);
      };
    }, []);
  
    useEffect(() => {
      const setResponsiveness = () => {
        return window.innerWidth < 900
          ? setState((prevState) => ({ ...prevState, mobileView: true }))
          : setState((prevState) => ({ ...prevState, mobileView: false }));
      };
  
      setResponsiveness();
  
      window.addEventListener("resize", () => setResponsiveness());
  
      return () => {
        window.removeEventListener("resize", () => setResponsiveness());
      };
    }, []);
  
    const displayDesktop = () => {
      return (
        <Toolbar className={toolbar}>
          {alsalamLogo}
            <div>{getMenuButtons()}</div>
          
          
        </Toolbar>
      );
    };
  
    const displayMobile = () => {
      const handleDrawerOpen = () =>
        setState((prevState) => ({ ...prevState, drawerOpen: true }));
      const handleDrawerClose = () =>
        setState((prevState) => ({ ...prevState, drawerOpen: false }));
  
      return (
        <Toolbar>
          <IconButton
            {...{
              edge: "end",
              color: "inherit",
              "aria-label": "menu",
              "aria-haspopup": "true",
              onClick: handleDrawerOpen,
            }}
            sx={{
              color:"#15558D" 
            }}
          >
            <MenuIcon />
          </IconButton>
          <div>{alsalamLogo}</div>
          
  
          <Drawer
            {...{
              anchor: "right",
              open: drawerOpen,
              onClose: handleDrawerClose,
            }}
          >
            <div className={drawerContainer}>{getDrawerChoices()}</div>
          </Drawer>
          
  
          
        </Toolbar>
      );
    };
  
    const getDrawerChoices = () => {
      return headersData.map(({ label, href }) => {
        return (
          <Link
            {...{
              component: RouterLink,
              to: href,
              color: "inherit",
              style: { textDecoration: "none" },
              key: label,
            }}
          >
            <MenuItem>{label}</MenuItem>
          </Link>
        );
      });
    };
  
    const alsalamLogo = (
    <div style={{
        justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'row', display: 'flex', paddingTop:'10px',paddingBottom:'10px'
        }}>
       <img
            src={`${require('../../../assets/imgs/alsalam_logo.jpg')}`}
            alt={"شركة السلام العامة"}
            loading="lazy"
            width={"80px"}
            height={"80px"}
        />
        
        <div style={{
                justifyContent: 'center',
                flexDirection: 'column',
                display: 'flex',
                alignContent: 'center',
                marginRight: '10px',
                alignItems: 'center',
        }}>
            <Typography variant="h5" component="h1" >
                منصة الضرائب الطبية
            </Typography>
            <Typography variant="h6" component="h1" >
                شركة السلام العامة
            </Typography>
        </div>
        
        
    </div>
      
    );
  
    const getMenuButtons = () => {
      return headersData.map(({ label, href,sectionID }) => {
        if(href==="/listings")
        {
         
          return (
            <Button
            {...{
              key: label,
              
              // to: href,
              
            }}
            onClick={()=>{
              const anchor = document.querySelector('#'+sectionID)
              anchor.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }}
            sx={{
                    backgroundColor: '#15558D',
              color: '#fff',
              fontSize: '16px',
              marginLeft:'8px',
              borderRadius: '14px',
              paddingLeft: '10px',
              paddingRight: '10px',
            }}
            >
              {label}
            </Button>
          )
        }
        else{
          return (
            <Button
              {...{
                key: label,
                color: "inherit",
                  // to: href,
              
            }}
            onClick={()=>{
              const anchor = document.querySelector('#'+sectionID)
              anchor.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }}
            >
              {label}
            </Button>
          );
        }
        
      });
    };
  
    return (
      <header>
        <ThemeProvider theme={darkTheme}>
          <AppBar className={header} elevation={scrollPosition>0?5:0}>
            {mobileView ? displayMobile() : displayDesktop()}
          </AppBar>
        </ThemeProvider>
      </header>
    );
  }